import { useEffect, useState } from "react";

/** Umrechnung der OpenAI-Kontowährung (EUR) in USD für die Kostenzeilen der Conversions-Karte.
 *  Tageskurs der EZB über frankfurter.app (kein Key, CORS offen); bis der Kurs da ist oder
 *  wenn der Abruf scheitert, gilt der Fallback (Operator 2026-09-14: „immer aktuellen Kurs"). */
export const EUR_USD_FALLBACK = 1.15;
const FX_KEY = "fx:eurusd";

export function toUsd(amount: number, currency: string, eurUsd: number = EUR_USD_FALLBACK): number {
  const c = (currency || "USD").toUpperCase();
  if (c === "USD") return amount;
  if (c === "EUR") return amount * eurUsd;
  return amount;
}

/** Liefert den aktuellen EUR→USD-Kurs; letzter bekannter Kurs aus localStorage als Zwischenwert. */
export function useEurUsd(): number {
  const [rate, setRate] = useState<number>(() => {
    try {
      const v = Number(localStorage.getItem(FX_KEY));
      return v > 0.5 && v < 2 ? v : EUR_USD_FALLBACK;
    } catch { return EUR_USD_FALLBACK; }
  });
  useEffect(() => {
    let cancelled = false;
    fetch("https://api.frankfurter.dev/v1/latest?base=EUR&symbols=USD")
      .then((r) => r.json())
      .then((j: { rates?: { USD?: number } }) => {
        const v = j?.rates?.USD;
        if (!cancelled && typeof v === "number" && v > 0.5 && v < 2) {
          setRate(v);
          try { localStorage.setItem(FX_KEY, String(v)); } catch { /* egal */ }
        }
      })
      .catch(() => { /* Fallback bleibt */ });
    return () => { cancelled = true; };
  }, []);
  return rate;
}
